<div class="service-visits-drawer" data-testid="service-visits-drawer">
  <div class="service-visits-drawer__header">
    <h2 class="service-visits-drawer__title">Visitas Onetrack</h2>
    <button
      class="service-visits-drawer__close"
      (click)="onClose()"
      data-testid="service-visits-drawer-close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="service-visits-drawer__content">
    @if (isLoading()) {
      <div class="service-visits-drawer__state">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    } @else if (error()) {
      <div class="service-visits-drawer__state service-visits-drawer__state--error">
        {{ error() }}
      </div>
    } @else if (visits().length === 0) {
      <div class="service-visits-drawer__state">
        <app-horus-message-general 
          nameIcon="noDataMessageIcon" 
          btnAction="ENTENDIDO"
          (action)="onClose()"
          size="S">
          <span class="warning-title">No podemos ejecutar la acción</span><br>
          <span>Aún no tenemos <strong>información</strong><br>
          <strong>sobre este servicio.</strong></span>
        </app-horus-message-general>
      </div>
    } @else {
      <mat-accordion>
      @for (visit of visits(); track visit.serviceId; let i = $index) {
        <mat-expansion-panel class="visit-panel" [attr.data-testid]="'visit-panel-' + i" [expanded]="i === 0">
          <mat-expansion-panel-header class="visit-panel__header" [attr.data-testid]="'visit-panel-header-' + i">
            <div class="visit-panel__header-content">
              <mat-icon class="visit-panel__icon">build</mat-icon>
              <span class="visit-panel__title">VISITA {{ visits().length - i }} DE {{ visits().length }}</span>
            </div>
          </mat-expansion-panel-header>

          <div class="visit-panel__content">
            <div class="visit-info">
              <div class="visit-info__row">
                <span class="visit-info__label">ORDEN DE SERVICIO</span>
                <span class="visit-info__value">{{ drawerData.serviceOrderNumber || visit.serviceId }}</span>
              </div>

              <div class="visit-info__row">
                <span class="visit-info__label">FECHA DE SERVICIO</span>
                <span class="visit-info__value">{{ (formatDate(visit.createdAt) | date: 'dd/MM/yy') || '-' }}</span>
              </div>

              <div class="visit-info__row">
                <span class="visit-info__label">ESTADO</span>
                <span class="visit-info__value" [ngClass]="getStatusClass(visit)">
                  {{ getStatusLabel(visit) }}
                </span>
              </div>

              <div class="visit-info__row">
                <span class="visit-info__label">MOTIVO</span>
                <span class="visit-info__value">{{ visit.subStatus || '-' }}</span>
              </div>

              @if (visit.images.length > 0) {
                <div class="visit-info__row visit-info__row--images">
                  <span class="visit-info__label">IMÁGENES</span>
                  <div class="visit-images">
                    @for (image of visit.images; track image.imageUrl; let imgIndex = $index) {
                      <div
                        class="visit-images__thumbnail"
                        (click)="onViewImages(visit.images, $event)"
                        [attr.data-testid]="'visit-images-thumbnail-' + i + '-' + imgIndex"
                      >
                        <img [src]="image.imageUrl" [alt]="'Imagen ' + (imgIndex + 1)">
                      </div>
                    }
                  </div>
                </div>
              }

              @if (visit.observation) {
                <div class="visit-info__row visit-info__row--observation">
                  <span class="visit-info__label">OBSERVACIONES</span>
                  <div class="visit-observation">
                    <p class="visit-observation__date">{{ formatDate(visit.createdAt) | date: 'dd/MM/yy HH:mm' }}</p>
                    <p class="visit-observation__text">{{ visit.observation }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </mat-expansion-panel>
      }
      </mat-accordion>
    }
  </div>
</div>
